module.exports = __webpack_public_path__ + "static/media/Sopilka3.8531f92c.mp3";